var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9287fc62a2f4dfc110551e21ac81fce5bc57d340"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-future-of-tourism@travpro-mobile"]={id:"9287fc62a2f4dfc110551e21ac81fce5bc57d340"};
      